/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CursorPaginationDto } from '../../models/cursor-pagination-dto';
import { PreRegistrationDto } from '../../models/pre-registration-dto';

export interface PreRegistrationControllerSearchCursorV1$Params {

/**
 * 페이지 크기
 */
  pageSize?: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 커서
 */
  cursor?: string;

/**
 * 이벤트 ID
 */
  eventId?: string;

/**
 * 마케팅 동의 여부
 */
  isMarketingAgreed?: boolean;

/**
 * 출처
 */
  sourceType?: 'MILLIONSHOW' | 'GOODSPACE' | 'ALLHOUSE' | 'STARTFAIR' | 'AGRITEX' | 'GIFTFAIR';
}

export function preRegistrationControllerSearchCursorV1(http: HttpClient, rootUrl: string, params?: PreRegistrationControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<PreRegistrationDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, preRegistrationControllerSearchCursorV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('cursor', params.cursor, {});
    rb.query('eventId', params.eventId, {});
    rb.query('isMarketingAgreed', params.isMarketingAgreed, {});
    rb.query('sourceType', params.sourceType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CursorPaginationDto & {
      'items'?: Array<PreRegistrationDto>;
      }>;
    })
  );
}

preRegistrationControllerSearchCursorV1.PATH = '/api/v1/pre-registration/search/cursor';
